<section>
  <app-category-filter (filterEmmiter)="setFilter($event)"></app-category-filter>
  <app-category-list [filter]="filter"></app-category-list>
</section>
